module.exports = __webpack_public_path__ + "static/video-poster-intro-63bfb18173eaaae10d8e2d64df474edc.png";